import { useChartIconSources } from '@futrli/predict/dashboard/hooks';
import { APP_WIDGET_NAMES, RestIconNameTypes, WIDGET_TYPES } from '@futrli/predict/report-builder/types';
import React from 'react';
import SVGInlineReact from 'svg-inline-react';

type WidgetTypesEnumToType = `${WIDGET_TYPES}`;
type AppWidgetNamesEnumToType = `${APP_WIDGET_NAMES}`;

export const ICON_SIZES = {
  default: 24
};

export type UIChartsIconName = WidgetTypesEnumToType | AppWidgetNamesEnumToType | RestIconNameTypes;

export type UIChartsIconSize = keyof typeof ICON_SIZES;

export interface UIChartsIconProps extends React.SVGAttributes<SVGSVGElement> {
  iconName: UIChartsIconName;
  size?: UIChartsIconSize;
}

function getSize(size?: UIChartsIconSize): Pick<React.SVGAttributes<SVGSVGElement>, 'width' | 'height'> {
  const pixels = size ? ICON_SIZES[size] : ICON_SIZES.default;

  return {
    width: pixels,
    height: pixels
  };
}

export const UIChartsIcon = ({ iconName, size, ...props }: UIChartsIconProps) => {
  const chartIconSources = useChartIconSources();
  return (
    <SVGInlineReact {...getSize(size)} {...props} src={chartIconSources[iconName]} raw={true} />
  )
};
